import * as React from "react";

import type { FeatureFlagSet, LeadFormFlags } from "client/defs";

import { ValueOf } from "client/lib/apt-merchant";

export interface VariantProps {
  type: ValueOf<keyof FeatureFlagSet> | LeadFormFlags[];
}

export const Variant: React.FC<VariantProps> = ({
  children,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  type,
}) => <>{children}</>;
